import React from 'react';
import visaIcon from '../../../../assets/Dashboard/Profile/components/Wallet/visaIcon.png';
import masterIcon from '../../../../assets/Dashboard/Profile/components/Wallet/masterIcon.png';
import amexIcon from '../../../../assets/Dashboard/Profile/components/Wallet/amexIcon.png';
import discoverIcon from '../../../../assets/Dashboard/Profile/components/Wallet/discoverIcon.png';
import './CardDisplay.css';

const cardIcons = {
  visa: visaIcon,
  mastercard: masterIcon,
  amex: amexIcon,
  discover: discoverIcon
};

const CardDisplay = ({ method, isDefault }) => {
  if (!method) return null;

  const cardType = method.cardType || "";
  const cardNumber = method.cardNumber || "";
  const expiryMonth = method.expiryMonth || "";
  const expiryYear = method.expiryYear || "";

  const lastFour = cardNumber ? cardNumber.toString().slice(-4) : "----";
  const icon = cardIcons[cardType] || null;

  const formattedYear = expiryYear
    ? expiryYear.toString().slice(-2)
    : "--";

  return (
    <div className="wallet-card-display">

      {/* Brand Icon */}
      {icon && (
        <img 
          src={icon}
          alt={cardType + " logo"}
          className="wallet-card-logo"
        />
      )}

      <div className="wallet-card-info">
        <div className="wallet-card-number">
          **** **** **** {lastFour}
        </div>

        <div className="wallet-card-details">
          <span className="wallet-expiry-date">
            Expires {expiryMonth}/{formattedYear}
          </span>
        </div>
      </div>

      {/* DEFAULT TAG */}
      {isDefault ? (
        <div className="wallet-default-tag">
          Default
        </div>
      ) : null}

    </div>
  );
};

export default CardDisplay;
